import React from "react";
import "./Footer.css";
// import isolationlogo from "../../Assets/my-aptitude-ai-uslot.png";
import uslotAILogo from "../../Assets/uslot-ai-logo.png";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation("footer");

  return (
    <div className="footer-container !bg-white border-t border-gray-300">
      <div className="flex justify-between md-max:flex-col md-max:gap-10 items-center">
        <div className="footer-content-1">
          {/* <img
            src={uslotAILogo}
            alt="logo"
            className="object-contain h-[3.75rem]"
          /> */}
          <img
            src={"/uslot-black.png"}
            alt="USLOT"
            className="object-contain h-[3.75rem]"
          />
          <p className="!text-base !text-black mt-4 leading-6">
            {t("description")}
          </p>
        </div>
        <div className="flex md-max:flex-col gap-8">
          <div className="flex flex-col gap-3">
            <h1 className="!text-black text-base font-bold">
              {t("quickLinks.title")}
            </h1>
            {t("quickLinks.links", { returnObjects: true }).map(
              (link, index) => (
                <a href={link.href} key={index}>
                  <h2 className="!text-black text-base">{link.text}</h2>
                </a>
              )
            )}
          </div>
          <div className="flex flex-col gap-4" dir="ltr">
            <h1 className="!text-black text-base font-bold">
              {t("contact.title")}
            </h1>

            {t("contact.links", { returnObjects: true }).map((link, index) => (
              <a href={link.href} key={index}>
                <h2 className="!text-black text-base">{link.text}</h2>
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="footer-line"></div>
    </div>
  );
};

export default Footer;
